<div class="dash-widget fade-in">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">show_chart</mat-icon>
      </div>
      {{ 'GUI.dashboard.labels.Weekly Exam Breakdown' | translate }}
      <app-scope-chip [scope]="scope()"></app-scope-chip>
    </div>
    <div class="dw-header__right">
      @if (canFilterByDoctor()) {
      <select
        class="dw-period-select"
        #doctorSelect
        (change)="onDoctorChange(doctorSelect.value)"
      >
        <option value="" [selected]="selectedDoctor() === null">
          {{'GUI.dashboard.selects.all' | translate}}
        </option>
        @for (d of doctors(); track d.uid) {
        <option [value]="d.uid" [selected]="selectedDoctor() === d.uid">{{ d.name }}</option>
        }
      </select>
      }
      <select
        class="dw-period-select"
        #examPeriodSelect
        (change)="onExamPeriodChange(examPeriodSelect.value)"
      >
        <option value="today" [selected]="examPeriod() === 'today'">{{ 'GUI.dashboard.selects.today' | translate }}</option>
        <option value="week" [selected]="examPeriod() === 'week'">{{ 'GUI.dashboard.selects.this week' | translate }}</option>
        <option value="month" [selected]="examPeriod() === 'month'">{{ 'GUI.dashboard.selects.this month' | translate }}</option>
      </select>
      @if (examTrend() !== null) {
      <span
        class="kpi__trend kpi__trend--inline"
        [class]="'kpi__trend--' + examTrend()!.tone"
        ><bdi>{{ examTrend()!.stats }}</bdi> {{ examTrend()!.phrase }}</span
      >
      }
    </div>
  </div>

  <div class="exam-chart-row">
    <div class="donut-wrap">
      @if (loading || loadingExams()) {
      <div class="skel skel--circle" style="width: 120px; height: 120px"></div>
      <div class="donut-legend">
        @for (_ of [1,2,3]; track $index) {
        <div class="skel" style="width: 80px; height: 12px"></div>
        }
      </div>
      } @else {
      <div class="donut-canvas-wrap">
        <canvas
          baseChart
          width="120"
          height="120"
          [data]="donutChartData()"
          [options]="donutChartOptions"
          [type]="'doughnut'"
        ></canvas>
        <div class="donut__hole">
          <div class="donut__num">{{ examTotal() }}</div>
          <div class="donut__lbl">{{ donutHoleLabel() }}</div>
        </div>
      </div>
      <div class="donut-legend">
        @for (s of examSlices(); track s.label) {
        <div class="donut-legend-item">
          <span class="donut-dot" [style.background]="s.color"></span>
          {{ s.short }}
        </div>
        }
      </div>
      }
    </div>

    <div class="exam-bars">
      @if (loading || loadingExams()) { @for (_ of [1,2,3,4]; track $index) {
      <div class="exam-bar">
        <div class="skel" style="width: 140px; height: 14px"></div>
        <div class="skel skel--bar"></div>
        <div class="skel" style="width: 20px; height: 14px"></div>
      </div>
      } } @else { @for (s of examSlices(); track s.label) {
      <div class="exam-bar">
        <div class="exam-bar__label">{{ s.label }}</div>
        <div class="exam-bar__track">
          <div
            class="exam-bar__fill"
            [style.width.%]="s.percent"
            [style.background]="s.color"
          ></div>
        </div>
        <div class="exam-bar__val">{{ s.value }}</div>
      </div>
      } @empty {
      <span class="banner-empty">{{'GUI.dashboard.labels.no exams recorded' | translate}} {{ donutHoleLabel() }}</span>
      } }
    </div>
  </div>

  <div class="divider divider--tight"></div>

  <div class="dw-header dw-header--inline">
    <div class="dw-title dw-title--sm">
      <mat-icon
        style="
          color: var(--muted);
          font-size: 18px;
          width: 18px;
          height: 18px;
          line-height: 18px;
        "
        >access_time</mat-icon
      >
      {{ 'GUI.dashboard.labels.recent exams' | translate }}
    </div>
  </div>
  <div class="recent-exams">
    @if (loading || loadingExams()) { @for (_ of [1,2,3]; track $index) {
    <div class="recent-exam-row">
      <div class="skel skel--circle" style="width: 32px; height: 32px"></div>
      <div class="recent-exam-row__info" style="flex: 1">
        <div class="skel" style="width: 140px; height: 15px; margin-bottom: 6px"></div>
        <div class="skel" style="width: 90px; height: 12px"></div>
      </div>
      <div class="skel" style="width: 80px; height: 28px; border-radius: 20px"></div>
    </div>
    } } @else { @for (r of recentExams(); track r.examIndex) {
    <div class="recent-exam-row">
      <div class="recent-exam-row__av">{{ r.initials }}</div>
      <div class="recent-exam-row__info">
        <div class="recent-exam-row__name">{{ r.name }}</div>
        <div class="recent-exam-row__meta">
          <span class="tag recent-exam-row__type" [class]="'tag--' + r.typeTag"
            >{{ r.type }}</span
          >
          <span class="recent-exam-row__when">{{ r.when }}</span>
        </div>
        @if (separatedMode && r.openerName) {
        <div class="recent-exam-row__opener">{{ r.openerName }}</div>
        }
      </div>
      <a
        class="recent-exam-row__link"
        [class.recent-exam-row__link--viewonly]="r.viewOnly"
        (click)="openExam(r)"
        (keyup.enter)="openExam(r)"
        (keyup.space)="openExam(r)"
        tabindex="0"
      >
        {{ r.viewOnly ? 'View exam' : ('GUI.dashboard.buttons.open exam' | translate) }}
        <mat-icon>chevron_right</mat-icon>
      </a>
    </div>
    } @empty {
    <span class="banner-empty">
      {{'GUI.dashboard.labels.no recent exams available' | translate}}
    </span>
    } }
  </div>
</div>
